export enum QMessageBoxAction {
  confirm = 'confirm',
  cancel = 'cancel',
  close = 'close'
}
